// Minnesotaänger Mini App — v1 global init.
// New code (not from telegram-tt). v1 has no cache, no passcode, no
// multi-tab coordination — the global tree is always a fresh clone of
// INITIAL_GLOBAL_STATE. Kept as a function so index.tsx's call site stays
// unchanged.

import type { GlobalState } from '../global/types';

import { getGlobal, setGlobal } from '../global/index';
import { INITIAL_GLOBAL_STATE } from '../global/initialState';
import { cloneDeep } from './iteratees';

export async function initGlobal(force: boolean = false, _prevGlobal?: GlobalState) {
  if (!force && 'byTabId' in getGlobal()) {
    return;
  }

  setGlobal(cloneDeep(INITIAL_GLOBAL_STATE));
}
